module.exports = __webpack_public_path__ + "toolkit-static/img/2-nothing.673cf914.png";